<template>
  <div class="article" :style="{'width':width}">
    <h1>鹿驾网服务协议</h1>
    <p>
      本协议生效日期2019年11月29日
    </p>
    <p>
      <strong>1. 重要须知</strong>
    </p>
    <p>
      1.1 鹿驾网系沈阳美行科技有限公司建设并运营，鹿驾网根据《鹿驾网服务协议》（以下简称"本协议"）为用户提供各类产品或服务等（以下统称“本服务”）。“鹿驾网”是指网站运营方沈阳美行科技有限公司及其相关服务可能存在的运营关联单位。涉及具体产品服务的，将由有资质的服务商提供。“用户”是指本服务的使用人，本协议也使用“您”来称呼用户。
    </p>
    <p>
      1.2 在您使用本服务之前（简称为“鹿驾网产品或服务”），
      <strong class="under-line">
        请您务必认真阅读并充分理解《鹿驾网服务协议》、《隐私政策》以及开通或使用某项服务的附加协议（统称为“本协议”），特别是一些重要条款，该等条款可能以粗体下划线方式进行标识，请您务必认真阅读。如果您对本协议条款有疑问，请通过鹿驾网客服进行询问，鹿驾网将向您解释本协议相关内容。一旦您开始使用本服务，即表示您已经理解并同意本协议，本协议即构成您与鹿驾网之间具有法律约束力的法律文件。
      </strong>
    </p>
    <p>
      1.3
      <strong>
        若您未满18周岁则属于未成年人用户，未成年人用户请在监护人监护、指导下，阅读理解本协议。否则鹿驾网将不能向您提供服务，因此给鹿驾网或第三方造成损失的，您须承担相应的赔偿责任。
      </strong>
    </p>
    <p>
      1.4 鹿驾网有权对本协议进行修订，且无须单独和事先通知您。本协议一旦发生变动，鹿驾网将会在产品或服务和/或相关网站上公布修订后的本协议。
      <strong class="under-line">
        您理解并同意，如果您在本协议修订版本公布后继续使用本服务的，即视为您同意修订后的本协议。
      </strong>
    </p>
    <p>
      1.5本协议的执行、解释及争议的解决均适用中华人民共和国法律，且不考虑任何冲突法。
      <strong class="under-line">
        您与鹿驾网就本服务的使用、本协议内容发生任何争议的，双方应友好协商解决；如双方无法协商解决争议时，双方同意应将争议提交至被告所在地人民法院裁决。
      </strong>
    </p>
    <p>
      <strong>
        2. 注册和账号
      </strong>
    </p>
    <p>
      2.1 您可使用您本人实名登记所有的手机号码在本平台中创建一个登录账号并设置登录密码。通过该账号及密码，您即可使用本平台的本产品或服务。
    </p>
    <p>
      <strong>
        2.2 您应当保证注册时您所填写的信息是真实、完整、有效和准确的。如有合理理由怀疑您提供的信息是不实、不完整、失效或错误的，我们有权向您确认并要求您予以改正或补充，如果您提供的信息不符合鹿驾网的注册、登录或使用要求，我们有权拒绝您的注册、登录或使用。由于您提供的不真实、不完整、失效或错误的信息导致您无法正常使用本产品或服务，或者受到任何法律责任或行政责任的，我们不承担任何责任。
      </strong>
    </p>
    <p>
      <strong>
        3. 服务内容
      </strong>
    </p>
    <p>
      3.1 本服务的具体内容主要包括
      <strong class="under-line">
        ：在鹿驾网网站中发布、POI、问答、点评、游记、路线、上传图片或音视频等内容；发布或参加各类线上及线下活动；发布并分享对文章、话题、活动、图片、音视频的评论（以下统称“内容”）。
      </strong>
      您理解并同意，
      <strong class="under-line">
        本服务是按照现有技术和条件所能达到的现状提供的。
      </strong>
      鹿驾网会尽最大努力向您提供服务，确保服务的连贯性和安全性；但
      <strong class="under-line">
        鹿驾网不能随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力、病毒、 木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。对于任何用户信息或个人化设定之时效、删除、传递错误、未予储存或其它任何问题，鹿驾网均不承担任何责任。鹿驾网保留有权不经事先通知为升级、维护或其它目的暂停本服务全部或任何部分。
      </strong>
    </p>
    <p>
      <strong class="under-line">
        3.2 除非本协议另有明确规定，鹿驾网内任何新增的本服务以及对已有本服务内容的任何升级或更新版本，均受到本协议的规范。
      </strong>
    </p>
    <p>
      3.3 鹿驾网在提供服务过程中可以通过各种方式投放各种商业性广告或其他任何类型的商业信息（包括由第三方发布或发送的信息），您同意并接受鹿驾网通过【平台内推送】或其他任何方式向您发送商品或服务相关商业信息。
      <strong class="under-line">
        对于该等商业性广告或其他商业信息，您应当自行甄别并承担风险。
      </strong>
    </p>
    <p>
      3.4 鹿驾网依法为用户提供本服务，但是
      <strong class="under-line">
        用户应对其使用鹿驾网自行承担责任及风险，鹿驾网在任何情况下不就因使用或不能使用鹿驾网提供的服务所发生的特殊的、意外的、直接或间接的损失承担赔偿责任。
      </strong>
    </p>
    <p>
      <strong>
        4. 用户使用基本规则
      </strong>
    </p>
    <p>
      4.1 在使用本服务过程中，您承诺遵守以下约定:
    </p>
    <p>
      1）在使用本产品或服务过程中实施的所有行为均遵守国家法律法规及本协议的规定，
      <strong class="under-line">
        不违背社会公共利益及不损害他人的合法权益。
      </strong><br/>
      2）不对鹿驾网进行商业性利用，包括但不限于
      <strong class="under-line">
        未经鹿驾网的事先书面同意，对鹿驾网上的信息和数据进行复制、下载、保存、加工、转载或传播等；未经鹿驾网书面许可的从事商业广告行为，包括但不限于将广告函件、促销资料、垃圾邮件等，加以上载、张贴、发送电子邮件、发送站内信或以其它方式发布、传送、传播、储存或提供。
      </strong><br/>
      <strong class="under-line">
        3）不使用任何装置、软件或程序干扰或试图干预鹿驾网的正常运作或本服务的正常使用，不在鹿驾网上或线下进行与本服务有关的任何兑换或转让等交易活动。
      </strong><br/>
      <strong class="under-line">
        4）不侵犯任何人的知识产权，包括但不限于不得将侵犯任何人的专利、商标、著作权、商业秘密或其他专属权利。
      </strong><br/>
      <strong class="under-line">
        5）不侵犯涉密信息，包括但不限于不得将无权传送的内容（例如商业秘密、内部资料、机密资料、个人信息等）进行上载、张贴、发送电子邮件或以其它方式发布、传送、传播、储存、或提供。
      </strong><br/>
      <strong class="under-line">
        6）不侵犯任何人的肖像权、隐私权。
      </strong>
    </p>
    <p>
      4.2 您可在使用本服务发布文字、图片、音视频及其他信息内容，但不得使用鹿驾网服务发送或传播敏感信息和违反国家法律法规政策的信息，此类信息包括但不限于：
      <br/>
      <strong class="under-line">
        1）反对宪法所确定的基本原则的；<br/>
        2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br/>
        3）损害国家荣誉和利益的；<br/>
        4）煽动民族仇恨、民族歧视，破坏民族团结的；<br/>
        5）破坏国家宗教政策，宣扬邪教和封建迷信的；<br/>
        6）散布谣言，扰乱社会秩序，破坏社会稳定的；<br/>
        7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br/>
        8）侮辱或者诽谤他人，侵害他人合法权益的；<br/>
        9）含有法律、行政法规禁止的其他内容的。
      </strong>
    </p>
    <p>
      4.3 如您违反本协议规定，应由您自行承担相应的责任，并确保我们及第三方服务提供商免于因此受到任何损失。
      <strong class="under-line">
        鹿驾网有权在不通知用户的情况下删除用户发布的内容，
      </strong>
      同时如果鹿驾网有理由认为用户的任何行为，包括但不限于用户的任何言论、账号、昵称或其它行为，违反或可能违反国家法律和法规的任何规定或影响到鹿驾网的利益，
      <strong class="under-line">
        鹿驾网可在任何时候不经任何事先通知单方停止向用户提供服务，并无需对用户承担任何义务。
      </strong>
    </p>
    <p>
      <strong>5. 用户隐私保护</strong>
    </p>
    <p>
      5.1 鹿驾网非常重视对用户个人信息的保护。
      <strong class="under-line">
        鹿驾网将按照本协议及《隐私政策》的规定收集、使用、储存和分享您的个人信息。
      </strong>
      本协议对个人信息保护规定的内容与上述《隐私政策》有相冲突的，及本协议对个人信息保护相关内容未作明确规定的，均应以《隐私政策》的内容为准。
    </p>
    <p>
      5.2 保护用户隐私是鹿驾网的一项基本政策，鹿驾网不对外公开或向第三方提供用户的注册资料及用户在使用网络服务时存储在鹿驾网的非公开内容，但
      <strong class="under-line">
        下列情况除外：<br/>
        1）事先获得用户的明确授权； <br/>
        2）与国家安全、国防安全直接相关的；与公共安全、公共卫生、重大公共利益直接相关的；<br/>
        3）用于维护我们产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务故障；<br/>
        4）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br/>
        5）法律法规规定的其他情形。
      </strong>
    </p>
    <p>
      <strong class="under-line">
        5.3 如您认为您的个人信息被鹿驾网超目的使用、或被其他用户侵权，请立即与鹿驾网联系，并按照要求提供相应的证明资料，鹿驾网将及时调查核实处理。
      </strong>
    </p>
    <p>
      <strong>6. 知识产权</strong>
    </p>
    <p>
      6.1 除法律法规明确规定，或另有明确协议约定之外，
      <strong class="under-line">
        鹿驾网网站、产品和服务所依托软件的著作权、专利权、网站架构、程序设计及其他相关权利归鹿驾网所有；鹿驾网使用的“鹿驾网”（文字）、（图形）以及其他注册商标、所有设计图样以及其他图样、产品、程序及服务名称等商业标识、商业名称，其著作权、商标权，或外观设计专利等权益归鹿驾网所有。上述知识产权均受到法律保护，未经鹿驾网书面许可，任何人不得以任何形式进行使用或创造相关衍生作品。
      </strong>
    </p>
    <p>
      6.2 用户在鹿驾网上传或发布的内容，
      <strong class="under-line">
        用户应保证其为著作权人或已取得相关权利人的合法授权，并且该内容不会侵犯任何第三方的合法权益，
      </strong>
      并保证该等内容具有准确性、真实性、正当性、合法性，且不得以任何形式侵犯第三人权益，因抄袭、转载、侵权等行为所产生的纠纷由用户自行解决，鹿驾网不承担任何法律责任。用户的内容侵犯了任何第三方的著作权或其他权利，第三方发出有效的权利通知时，鹿驾网有权在初步审核的基础上决定删除相关的内容。
    </p>
    <p>
      6.3 您接受本协议的条款即视为您将在鹿驾网的任何形式的文字、图片、音视频等知识产权信息的著作权，
      <strong class="under-line">
        包括但不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权等可由著作权人转让的其他权益，
      </strong>
      在法律规定的保护期限内免费授予鹿驾网全球非排他的许可使用权利及再授权给其他第三方使用并可以自身名义对第三方侵权行为进行维权的权利，维权形式包括但不限于以发送侵权通告函件、提起诉讼、申请仲裁等方式。
      <strong class="under-line">
        您同意将该等授权覆盖鹿驾网现有服务以及未来任何时候提供的服务。
      </strong>
      同时，对于用户提供、发布及在鹿驾网服务中形成的除个人信息外的文字、图片、视频、音频等非个人信息，
      <strong class="under-line">
        用户同意鹿驾网存储、使用、复制、修订、编辑、发布、展示、翻译、分发用户的非个人信息或制作其派生作品，
      </strong>
      并以已知或日后开发的形式、媒体或技术将上述信息纳入其它作品内。
      <strong class="under-line">
        您理解并确认，本服务协议已经构成《著作权法》第二十五条所规定的书面协议，其效力及于用户在鹿驾网网站、产品及服务等载体发布的任何受著作权法保护的作品内容，无论该内容形成于本协议签订前还是本协议签订后。无论用户以注册或不注册等方式使用鹿驾网的服务均视为已充分理解并完全同意本协议的条款，明确向鹿驾网作出上述许可。
      </strong>
    </p>
    <p>
      6.4 【鹿驾网权利声明】用户在鹿驾网网站中发布的文字、图片、音视频及其它内容，将受到法律的保护；该等文字、图片、音视频及其它内容用户享有著作权，未经鹿驾网或其他权利人书面授权许可，任何人不得进行修改、出租、散布或衍生其他作品，不得为任何非私人或商业目的获取或使用本网站的任何部分或通过本网站可直接或间接获得的任何内容、服务或资料。
    </p>
    <p>
      6.5 鹿驾网不对用户发表的内容及其它附属品（如游记、行程、点评、问答、图片、笔记、音视频等）的正确性、客观性进行保证，用户发表的内容及其它附属品不代表鹿驾网观点和立场。
    </p>
    <p>
      <strong>
        7. 担保与保证
      </strong>
    </p>
    <p>
      7.1 鹿驾网按照适用的法律、法规、规章、规范、政策、强制标准、行业标准等的规定提供本产品或服务。
    </p>
    <p>
      7.2 您理解并同意，我们
      <strong>
        不就以下各项向您提供明示或默示的担保或保证：
      </strong><br/>
      1）本服务将符合您的实际或特定需求或目的；<br/>
      2）本服务的及时性、准确性、完整性及精确性；<br/>
      3）本服务将不受干扰、无中断、持续稳定或没有错误；<br/>
      4）使用本服务获得的任何结果或资料将是正确或可靠的；<br/>
      5）本服务中的任何错误、问题、故障都将得到更正或解决；<br/>
      6）经本服务购买或获得的任何产品、服务或其它内容符合您的期望；<br/>
      7）本服务中的外部链接及其指向的内容的及时性、准确性、稳定性、完整性、可靠性、有效性或没有错误。
    </p>
    <p>
      <strong>
        8. 免责及责任限制
      </strong>
    </p>
    <p>
      8.1 本服务可能会受到多种因素影响，包括但不限于您的原因、第三方原因、通信网络服务质量、连接故障、网络设备或系统维护、通讯或其他系统故障、电力故障、罢工、暴乱、火灾、洪水、风暴、爆炸、战争、政府行为、司法行政机关的命令、社会环境及其他不可抗力等；也可能受到各种安全问题的侵扰，例如您下载安装的其它软件或访问的其他网站中含有病毒、木马或其他恶意程序，威胁到您的设备和数据安全，进而影响本产品或服务的使用等。
      <strong class="under-line">
        除法律法规明确规定要求我们承担责任之外，因本款所述原因给您造成的任何损失由您本人自行承担，我们对此不承担责任。
      </strong>
    </p>
    <p>
      8.2 您理解并同意，在遵守法律法规和本协议的前提下，您是否使用本服务以及如何使用本服务均由您自行判断和自愿选择。
      <strong class="under-line">
        您理解并同意，除法律法规明确规定要求我们承担责任之外，您使用本服务及通过本服务获得任何商品、服务或内容所可能引发的任何风险和后果由您本人自行承担，我们对此不承担责任。在所有情况下，我们对于任何不能合理预见的损失或损害不承担责任。由于您违反法律法规或本协议使用本服务所产生的全部责任和后果，由您本人自行承担。
      </strong>
    </p>
    <p>
      <strong>
        9.终止服务
      </strong>
    </p>
    <p>
      9.1 出现以下情况时，
      <strong class="under-line">
        我们有权直接以注销账号的方式终止本协议。
      </strong><br/>
      1）用户死亡；<br/>
      2）盗用或冒用他人个人信息或手机号码注册或登录本平台，使用本服务；<br/>
      3）以虚假信息注册或登录使用本服务；<br/>
      4）不按照法律法规及本协议规定使用本产品或服务；<br/>
      5）妨碍其他用户的正常使用；<br/>
      6）扰乱本产品或服务的软件系统；<br/>
      7）侵害我们及第三方的知识产权；<br/>
      8）擅自更改、删除或毁损本产品或服务提供的各种信息；<br/>
      9）未经我们事先书面许可，擅自发布广告、传播谣言或发布淫秽暴力信息等；<br/>
      10）您提供的手机号码不存在或无法接收信息，且没有其他方式可以与您进行联系；或我们以其他联系方式通知您更改手机号码，而您在我们通知送达后3日内仍未更改为有效的手机号码；<br/>
      11）本协议或《隐私政策》修改时，您明示并通知本平台不愿接受本协议或《隐私政策》的修改内容；<br/>
      12）您存在其他违反法律法规或本协议规定的情况，我们认为应当终止本协议的情形。
    </p>
    <p>
      <strong class="under-line">
        9.2 另外，您同意鹿驾网基于其自行之考虑，因任何理由终止本服务，具体原因包含但不限于缺乏使用，或鹿驾网认为您已经违反本协议的情形。
      </strong>
    </p>
    <p>
      <strong>
        10. 通知送达及联系方式
      </strong>
    </p>
    <p>
      10.1 您在此同意，我们关于本服务、本协议内容变化、或与您使用本产品或服务相关的通知等所有通知均可通过网站公告、电子邮件、短信提醒或常规信件传送等任一方式进行。
    </p>
    <p>
      <strong class="under-line">
        10.2 上述通知于公布或发送之日即视为已送达收件人（即您）。您有责任通过上述方式查看任何此类通知。
      </strong>
    </p>
    <p>
      10.3 有关本服务的进一步详细说明，您可按照以下方式随时与我们联系：<br/>
      <span>
        （1）拨打客服电话【+86 15142048012】 ；
      </span><br/>
      <span>
        （2）发送电子邮件至【lujia@mxnavi.com】；
      </span><br/>
      <span>
        （3）发送常规信件至【辽宁省沈阳市浑南新区沈阳国际软件园E06，鹿驾网（收），+86 15142048012】。
      </span>
    </p>
  </div>
</template>
<script>
export default {
  props:{
    width: {
      type: String,
      default: "100%"
    }
  }
}
</script>
<style lang="less">
  .article{
    margin: 0 auto;
    text-align: left;
    h1{
      font-size: 40px;
      font-weight: bold;
    }
    p{
      margin:0;
      font-size: 15px;
      margin-bottom: 20px;
      line-height: 1.6em;
      strong{
        font-weight: 700;
      }
      .under-line{
        text-decoration: underline;
      }
      span{
        padding-left: 20px;
      }
    }
  }
</style>